<template>
    <div>
        Reset {{relatedEventName}} Reminder schedule.
    </div>
</template>

<script>
    import ReminderActionSummary from '@/modules/rules-engine/actions/reminder-action-summary';

    export default {
        name: 'reset-reminder-summary',
        extends: ReminderActionSummary,
    };
</script>
